import { Component, ElementRef, Injector, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatSidenav } from '@angular/material/sidenav';
import { ActivatedRoute } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { BaseComponent } from 'src/app/common/base/base.component';
import { ActionPendingCatalog, PendingResourcesType, Roles, StatusPendingCatalog } from 'src/app/common/enumerations/enumerations';
import { BeamlineShutterRelation, DetailsUsers } from 'src/app/components/catalogs/beamline-catalog/resource/resources';
import { ResourcesListNewComponent } from './resources-list-new/resources-list-new.component';
import { PrivilegeEnum } from 'src/app/common/enumerations/privilege-enum';
import { CatalogService } from '../catalog-service';
import { PendingResource } from 'src/app/services/pending-approvals/pending-approval';
import { BeamlineShutterRefresh } from '../store/beamline-shutter/beamline-shutter.action';

@Component({
  selector: 'app-beamline-catalog',
  templateUrl: './beamline-catalog.component.html',
  styleUrls: ['./beamline-catalog.component.scss']
})
export class BeamlineCatalogComponent extends BaseComponent {

  @ViewChild("sidenav") sidenav!: MatSidenav;
  @ViewChild("headerTop") headerTop!: ElementRef;
  @ViewChild(ResourcesListNewComponent) side!: ResourcesListNewComponent;

  disabled: boolean = false;
  showHistory?: boolean;

  loading = false;
  rowSelectionLoading = false;

  resourceRequired: boolean = false;

  filterCtrl = new FormControl();

  errorMessages: string[] = [];
  headerOnTop: boolean = false;

  valueFilter!: string;
  createdOn!: string;

  ///////
  tmpFilter!: string;
  condition!: string;
  filteredFilter: any[] = [];
  currentFilter: any;

  beamlineShutterRelation?: BeamlineShutterRelation;
  beamlineShutterRelations?: BeamlineShutterRelation[];
  beamlineShutterRelationsFiltered?: BeamlineShutterRelation[];
  beamlineShutterRelations$!: Observable<BeamlineShutterRelation[]>;
  beamlineShutterRelationsSubs!: Subscription;

  originalBeamlineShutterRelation?: BeamlineShutterRelation;
  detailUsers: DetailsUsers = { approverUserName: '', updateUserName: '', approvedOn: null, updatedOn: null };

  loadingMessage!: string;

  privileges = { canCreate: false };
  showChanges: boolean = false;

  pendingResource?: PendingResource;
  //////

  links = [{ id: 0, name: 'Details' }, { id: 1, name: 'KE Builder' }, { id: 2, name: 'RSS Database' }];
  selectedTab: number = 0;
  toggleVisible?: boolean;

  pendingResources?: PendingResource[];
  pendingResourcesFiltered?: PendingResource[];
  pendingResourcesSubs!: Subscription;

  constructor(
    protected override injector: Injector,
    private _route: ActivatedRoute,
    private _catalogService: CatalogService
  ) {
    super(injector);
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.checkPrivileges();
    }, 1000);
  }

  ngOnChanges(changes: SimpleChanges): void {

  }

  ngOnInit() {
    this.store.dispatch(new BeamlineShutterRefresh());
    this.moduleTitle = 'Beamline Catalog';
    this.checkPrivileges();
    this.loadPendingResources();
    this.loadBeamlineShutterRelations();
    let tab = this._route.snapshot.queryParams['tab'];
    if (!tab) tab = this._route.snapshot.params['tab'];
    if (tab)
      this.selectedTab = +tab;
  }

  selectedRow(row: BeamlineShutterRelation) {
    this.beamlineShutterRelation = row;
    this.setShowChanges();
    if (this.beamlineShutterRelation)
      this.detailUsers = this._catalogService.setUpdaterAndApprovalNames(this.beamlineShutterRelation);
  }

  startRowSelectionLoading() {
    if (!this.rowSelectionLoading) {
      this.rowSelectionLoading = true;
      this.loadingService.show();
    }
  }

  finishRowSelectionLoading() {
    if (this.rowSelectionLoading) {
      this.rowSelectionLoading = false;
      this.loadingService.hide();
    }
  }

  async onTabChanged(link: any) {
    if (await this.canDeactivate())
      this.showChanges = false;
    this.selectedTab = link.id;
  }


  loadPendingResources() {
    this.pendingResourcesSubs = this.store.select(state => state.PendingResources.data).subscribe((data: PendingResource[]) => {
      if (data?.length) {
        this.pendingResources = data.filter(pr => pr.action == ActionPendingCatalog.Create);
        this.loadBeamlineShutterRelations();
      }
    });
  }

  loadBeamlineShutterRelations() {
    this.beamlineShutterRelations$ = this.store.select(state => state.BeamlineShutter.data);
    this.beamlineShutterRelationsSubs = this.beamlineShutterRelations$.subscribe(data => {
      if (data?.length) {
        const pendingBeamlineShutter = this.pendingResources?.map(pr => { return this.toBeamlineShutterRelation(pr); }) ?? [];
        this.beamlineShutterRelations = data.concat(pendingBeamlineShutter);

        if (this.beamlineShutterRelation) {
          this.beamlineShutterRelation = this.beamlineShutterRelations.find(r => r.beamlineId == this.beamlineShutterRelation?.beamlineId || r.beamlineName == this.beamlineShutterRelation?.beamlineName || r.shutterName == this.beamlineShutterRelation?.shutterName);
          if (this.beamlineShutterRelation)
            this.beamlineShutterRelation.statusClass = this.side.getColor(this.beamlineShutterRelation);
        }
      }
      this.setShowChanges();
    });
  }

  public toBeamlineShutterRelation(pr: PendingResource): BeamlineShutterRelation {
    const relation = new BeamlineShutterRelation();
    relation.beamlineId = pr.resourceId;
    relation.beamlineName = pr.beamlineName || '';
    relation.shutterName = pr.shutterName || '';
    relation.statusClass = 'yellow';
    relation.status = StatusPendingCatalog.New;
    relation.beamlineStatus = 'New';
    relation.pendingResources = [pr];
    return relation;
  }

  async changeShow(e: any) {
    if (await this.canDeactivate()) {
      this.showChanges = e.checked;
    }
  }

  selectNewPending(id: number) {
    this.beamlineShutterRelation = this.beamlineShutterRelations?.find(r => {
      const pr = r.pendingResources?.find(p => p.id == id);
      return pr != undefined;
    });
  }

  setShowChanges() {
    this.toggleVisible = this.checkToggleVisible();
    this.showHistory = false;
    this.showChanges = false;
    switch (this.selectedTab) {
      case 0:
        this.pendingResource = this.beamlineShutterRelation?.pendingResources
          ?.filter(p => p.type === PendingResourcesType.Details)
          .at(-1);

        this.showChanges = ((this.isSA() || this.hasRoles([Roles.RP])) && this.currentUser?.id != this.pendingResource?.createdBy) || (this.hasPrivilege(PrivilegeEnum.BeamlineCatalog) && this.currentUser?.id == this.pendingResource?.createdBy);
        break;
      case 1:
        this.showChanges = false;
        break;
      case 2:
        this.showChanges = false;
        break;
    }
  }

  override ngOnDestroy(): void {
    this.beamlineShutterRelationsSubs?.unsubscribe();
    this.pendingResourcesSubs?.unsubscribe();

    super.ngOnDestroy();
  }

  clear() {
    this.errorMessages = [];
  }

  async create() {
    if (await this.canDeactivate()) {
      this.beamlineShutterRelation = new BeamlineShutterRelation();
      this.beamlineShutterRelation.beamlineName = 'New Beamline';
      this.beamlineShutterRelation.beamlineStatus = 'Draft';
      this.beamlineShutterRelation.statusClass = 'yellow';
    }
  }

  applyFilter(e: any) {
    if (!e)
      this.valueFilter = '';
    this.side.applyFilter(e);
  }

  buttonsVisible: boolean | null = false;

  checkPrivileges() {
    this.privileges.canCreate = this.hasRoles([Roles.ADM]);
    this.setHeights(30);
  }

  checkToggleVisible() {
    switch (this.selectedTab) {
      case 0:
        if (this.beamlineShutterRelation) {
          this.pendingResource = this._catalogService.getLastPendingResource(this.beamlineShutterRelation, PendingResourcesType.Details);
          return this.pendingResource?.status == 1;
        }
        return false;
      case 1:
        return false;
      case 2:
        if (this.beamlineShutterRelation) {
          this.pendingResource = this._catalogService.getLastPendingResource(this.beamlineShutterRelation, PendingResourcesType.Rss_Database);
          return this.pendingResource?.status == 1;
        }
        return false;
    }
    return false;
  }

  history(val: boolean) {
    this.showHistory = val;
    if (val) {
      this.originalBeamlineShutterRelation = this.utils.cloneDeep(this.beamlineShutterRelation);
      this.showChanges = false;
    }
    else {
      this.beamlineShutterRelation = this.utils.cloneDeep(this.originalBeamlineShutterRelation);
    }
  }
}

